import { connect } from 'react-redux'
import Component from './component'
import { sIsMD } from '../../redux/modules/browser'

const WithData = connect(state => ({
  isMD: sIsMD(state),
}))(Component)

export default WithData
